module.exports = __webpack_public_path__ + "media/images/static/offer/lp_s02-ttl_s-04dcabbbba5d6e1b4f46872272315bfa.png";